import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { Oops401Component } from './errors/401/oops401.component';
import { Oops404Component } from './errors/404/oops404.component';
import { Oops500Component } from './errors/500/oops500.component';
import { HomeComponent } from './home/home.component';

// const routes: Routes = [{ path: '', component: HomeComponent }];
// https://codecraft.tv/courses/angular/routing/parameterised-routes/

const routes: Routes = [
  // general
  {
    path: '',
    children: [
      {
        path: '**',
        component: HomeComponent,
      },
    ],
  }, // default
  { path: '401', component: Oops401Component },
  { path: '500', component: Oops500Component },
  // anything else
  { path: '**', component: Oops404Component },
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, {
      anchorScrolling: 'enabled',
      relativeLinkResolution: 'legacy',
      scrollOffset: [0, 154],
      scrollPositionRestoration: 'top',
    }),
  ],
  exports: [RouterModule],
})
export class AppRoutingModule {}
